import React, { useContext } from "react"
import { Link } from "react-router-dom"
import "../../../../styles/task.scss"
import StudentTable from "./table/StudentTable"
// import user from "../../../.assets/user-img.png"
import { SidebarContext } from "../../../auth/ProtectedRoute"

const Student = () => {
  const { userName, sidebarData } = useContext(SidebarContext)
  return (
    <div style={{ padding: "40px" }} className="roless">
      <div className="roless-wrapper">
        <div className="roless--tables">
          <div
            className="roless--tables-heading"
            style={{
              marginBottom: "10px",
            }}
          >
            <div
              className="roless--tables-heading-title"
              style={{
                padding: "5px 0px",
              }}
            >
              <h2>Student</h2>
            </div>
          </div>
          <div className="roless--tables--content">
            <StudentTable />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Student
